import type {
  SettingsFeatureBundle,
  SettingsOperatorPersona,
} from '../types';

export const resolveSettingsOperatorPersona = (
  bundle: Pick<SettingsFeatureBundle, 'storybookOperatorPersona' | 'resolveOperatorPersona'>,
): SettingsOperatorPersona => {
  try {
    return bundle.resolveOperatorPersona?.() ?? bundle.storybookOperatorPersona;
  } catch {
    return bundle.storybookOperatorPersona;
  }
};
